export default __webpack_public_path__ + "static/media/ep_19.5b772e11.png";